import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon.jsx';
import { Target } from 'lucide-react';
import { buildDraftRoomPath } from '../utils/draftRoomMode';

const UpcomingDraft = ({ draft, isAdmin = false, onEditDraftDate }) => {
  const navigate = useNavigate();
  
  if (!draft) return null;
  
  const draftDate = new Date(draft.startTime);
  const now = new Date();
  const draftInFuture = draftDate > now;
  
  // Calculate time until draft
  const getTimeUntilDraft = () => {
    if (!draftInFuture) return null;
    
    const diffMs = draftDate - now;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (diffDays > 0) {
      return `${diffDays} day${diffDays > 1 ? 's' : ''}, ${diffHours} hour${diffHours > 1 ? 's' : ''}`;
    } else if (diffHours > 0) {
      return `${diffHours} hour${diffHours > 1 ? 's' : ''}, ${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    } else {
      return `${diffMinutes} minute${diffMinutes > 1 ? 's' : ''}`;
    }
  };
  
  const timeUntilDraft = getTimeUntilDraft();
  
  return (
    <Card className="modern-card mb-5">
      <div className="modern-card-header">
        <h2 className="modern-card-title"><Icon icon={Target} size={18} className="me-2 align-middle" /> Upcoming Draft</h2>
        <p className="modern-card-subtitle">Get ready to build your team</p>
      </div>
      
      <div className="p-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
          <div>
            <h3 className="fs-5 text-primary mb-2">Draft Status</h3>
            <div className="d-flex align-items-center">
              <span className={`status-badge status-${draft.status === 'scheduled' ? 'warning' : draft.status === 'active' ? 'success' : 'primary'}`}>
                {draft.status.charAt(0).toUpperCase() + draft.status.slice(1)}
              </span>
            </div>
          </div>
          
          <div className="mt-3 mt-md-0">
            <h3 className="fs-5 text-primary mb-2">Draft Time</h3>
            <p className="mb-0">
              {draftDate.toLocaleDateString()} at {draftDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </p>
            {draftInFuture && timeUntilDraft && (
              <p className="text-secondary mb-0">
                <small>Starts in {timeUntilDraft}</small>
              </p>
            )}
          </div>
        </div>
        
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4">
          <div>
            <h3 className="fs-5 text-primary mb-2">Draft Method</h3>
            <p className="mb-0">
              {draft.draftMethod === 'snake' ? 'Snake Draft' : 'Linear Draft'}
            </p>
          </div>
          
          <div className="mt-3 mt-md-0">
            <h3 className="fs-5 text-primary mb-2">Draft Details</h3>
            <p className="mb-0">
              {draft.rounds} Rounds | {draft.timePerPick} seconds per pick
            </p>
            <p className="text-secondary mb-0">
              <small>Roster format: active scorers stay fixed while bench size scales with roster depth.</small>
            </p>
          </div>
        </div>
        
        <Button 
          variant="primary"
          className="w-100 btn-primary-modern"
          onClick={() => navigate(buildDraftRoomPath(draft._id, { chooseView: true }))}
        >
          {draft.status === 'active' ? 'Join Live Draft' : draft.status === 'scheduled' ? 'View Draft Room' : 'View Draft Results'}
        </Button>

        {isAdmin && draft.status === 'scheduled' && typeof onEditDraftDate === 'function' && (
          <button
            className="btn btn-outline-modern w-100 mt-2"
            type="button"
            onClick={onEditDraftDate}
          >
            Edit Draft Date
          </button>
        )}
      </div>
    </Card>
  );
};

export default UpcomingDraft;
